export default __webpack_public_path__ + "static/media/STL_Credit_Rating_2025.22c4d43a.pdf";